// Result type — functional error handling, no exceptions

export type Result<T, E = string> =
  | Readonly<{ ok: true; value: T }>
  | Readonly<{ ok: false; error: E }>;

export const ok = <T>(value: T): Result<T, never> =>
  ({ ok: true, value }) as const;

export const err = <E>(error: E): Result<never, E> =>
  ({ ok: false, error }) as const;

export const mapResult = <T, U, E>(
  result: Result<T, E>,
  fn: (value: T) => U,
): Result<U, E> =>
  result.ok ? ok(fn(result.value)) : result;

export const flatMapResult = <T, U, E>(
  result: Result<T, E>,
  fn: (value: T) => Result<U, E>,
): Result<U, E> =>
  result.ok ? fn(result.value) : result;
